import * as React from "react";
const ProfitsByAffiliate = (props) => (
  <svg
    width={34}
    height={33}
    viewBox="0 0 34 33"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <g filter="url(#filter0_di_6515_3914)">
      <g clipPath="url(#clip0_6515_3914)">
        <rect x={1} width={32} height={32} rx={10} fill="#27272A" />
        <g clipPath="url(#clip1_6515_3914)" filter="url(#filter1_dd_6515_3914)">
          <path
            d="M11.4 11.1999C11.4 8.5527 13.5528 6.3999 16.2 6.3999C18.8472 6.3999 21 8.5527 21 11.1999C21 13.8471 18.8472 15.9999 16.2 15.9999C13.5528 15.9999 11.4 13.8471 11.4 11.1999ZM24.748 19.4135L22.3152 19.0079C22.0168 18.9583 21.8 18.7023 21.8 18.3999C21.8 17.9591 22.1584 17.5999 22.6 17.5999H24.2C24.6416 17.5999 25 17.9591 25 18.3999H26.6C26.6 17.0767 25.5232 15.9999 24.2 15.9999V14.3999H22.6V15.9999C21.2768 15.9999 20.2 17.0767 20.2 18.3999C20.2 19.4879 20.9792 20.4079 22.052 20.5863L24.4848 20.9919C24.7832 21.0415 25 21.2975 25 21.5999C25 22.0407 24.6416 22.3999 24.2 22.3999H22.6C22.1584 22.3999 21.8 22.0407 21.8 21.5999H20.2C20.2 22.9231 21.2768 23.9999 22.6 23.9999V25.5999H24.2V23.9999C25.5232 23.9999 26.6 22.9231 26.6 21.5999C26.6 20.5119 25.8208 19.5919 24.748 19.4135ZM18.6 21.5999V18.3999C18.6 18.1711 18.6304 17.9511 18.6672 17.7327L18.6 17.5999H12.6C10.6152 17.5999 9 19.2151 9 21.1999V25.5999H21V25.2607C19.5896 24.6415 18.6 23.2359 18.6 21.5999Z"
            fill="url(#paint0_linear_6515_3914)"
          />
        </g>
      </g>
    </g>
    <defs>
      <filter
        id="filter0_di_6515_3914"
        x={0.5}
        y={0}
        width={33}
        height={33}
        filterUnits="userSpaceOnUse"
        colorInterpolationFilters="sRGB"
      >
        <feFlood floodOpacity={0} result="BackgroundImageFix" />
        <feColorMatrix
          in="SourceAlpha"
          type="matrix"
          values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
          result="hardAlpha"
        />
        <feOffset dy={0.5} />
        <feGaussianBlur stdDeviation={0.25} />
        <feComposite in2="hardAlpha" operator="out" />
        <feColorMatrix
          type="matrix"
          values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"
        />
        <feBlend
          mode="normal"
          in2="BackgroundImageFix"
          result="effect1_dropShadow_6515_3914"
        />
        <feBlend
          mode="normal"
          in="SourceGraphic"
          in2="effect1_dropShadow_6515_3914"
          result="shape"
        />
        <feColorMatrix
          in="SourceAlpha"
          type="matrix"
          values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
          result="hardAlpha"
        />
        <feOffset dy={0.5} />
        <feGaussianBlur stdDeviation={0.25} />
        <feComposite in2="hardAlpha" operator="arithmetic" k2={-1} k3={1} />
        <feColorMatrix
          type="matrix"
          values="0 0 0 0 1 0 0 0 0 1 0 0 0 0 1 0 0 0 0.15 0"
        />
        <feBlend
          mode="normal"
          in2="shape"
          result="effect2_innerShadow_6515_3914"
        />
      </filter>
      <filter
        id="filter1_dd_6515_3914"
        x={-22.5996}
        y={-19.7016}
        width={79.1992}
        height={79.2}
        filterUnits="userSpaceOnUse"
        colorInterpolationFilters="sRGB"
      >
        <feFlood floodOpacity={0} result="BackgroundImageFix" />
        <feColorMatrix
          in="SourceAlpha"
          type="matrix"
          values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
          result="hardAlpha"
        />
        <feOffset dy={10} />
        <feGaussianBlur stdDeviation={10} />
        <feColorMatrix
          type="matrix"
          values="0 0 0 0 0.118924 0 0 0 0 0.158031 0 0 0 0 0.570833 0 0 0 0.4 0"
        />
        <feBlend
          mode="normal"
          in2="BackgroundImageFix"
          result="effect1_dropShadow_6515_3914"
        />
        <feColorMatrix
          in="SourceAlpha"
          type="matrix"
          values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
          result="hardAlpha"
        />
        <feOffset dy={3.89851} />
        <feGaussianBlur stdDeviation={15} />
        <feColorMatrix
          type="matrix"
          values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.17 0"
        />
        <feBlend
          mode="normal"
          in2="effect1_dropShadow_6515_3914"
          result="effect2_dropShadow_6515_3914"
        />
        <feBlend
          mode="normal"
          in="SourceGraphic"
          in2="effect2_dropShadow_6515_3914"
          result="shape"
        />
      </filter>
      <linearGradient
        id="paint0_linear_6515_3914"
        x1={8.86401}
        y1={2.45493}
        x2={23.2032}
        y2={21.7212}
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="white" />
        <stop offset={1} stopColor="white" stopOpacity={0.65} />
      </linearGradient>
      <clipPath id="clip0_6515_3914">
        <rect x={1} width={32} height={32} rx={10} fill="white" />
      </clipPath>
      <clipPath id="clip1_6515_3914">
        <rect
          width={19.2}
          height={19.2}
          fill="white"
          transform="translate(7.40039 6.3999)"
        />
      </clipPath>
    </defs>
  </svg>
);
export default ProfitsByAffiliate;
